import { proxy } from 'valtio';

export const localState = proxy({
    isValidChange: false,
    accountType: 'table',
    userID: '',
    tableID: '',
    orderID: '',
});